import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudRadioButtonModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { OfficeModalModule } from '@office-ui/modal/modal.module';

import { ConfirmActionBusySlotComponent } from './confirm-action-busy-slot.component';

@NgModule({
	declarations: [ConfirmActionBusySlotComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudRadioButtonModule,
		FreudButtonModule,
		OfficeModalModule,
		FormsModule,
	],
	exports: [ConfirmActionBusySlotComponent],
})
export class ConfirmActionBusySlotModule {}
